"use client"

import React from "react"
import { useAuth0 } from "@auth0/auth0-react"
import GroupForums from "../Groups/GroupForums"
import crownLogo from "../../resources/CrownCracked.png"
import FishersOfMen from "../../resources/Fisherman.jpg"
import "../../styles/components/CommunityForum.css"

export default function CommunityForumV2({ renderRoadmap }) {
  const { isAuthenticated, loginWithRedirect } = useAuth0()

  return (
    <div className="community-forum-page">
      <div className="community-forum-hero" style={{ backgroundImage: `url(${FishersOfMen})` }}>
        <div className="community-forum-overlay" />
        <div className="community-forum-hero-content">
          <div className="community-forum-brand">
            <img src={crownLogo} alt="Thousand Year Kingdom crown" className="community-forum-logo" />
            <div>
              <p className="community-forum-eyebrow">Community</p>
              <h1 className="community-forum-title">Forum</h1>
              <p className="community-forum-subtitle">
                Share wisdom, ask questions, and collaborate with the entire Kingdom—threads are open to every member.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="community-forum-shell">
        {renderRoadmap}

        {isAuthenticated ? (
          <GroupForums forumTitle="Community Forum" isGlobalForum groupId={0} />
        ) : (
          <section className="community-forum-public-preview" aria-label="Community forum preview">
            <p className="community-extra-eyebrow">Members only</p>
            <h2 className="community-extra-title">Forum discussions open after sign in</h2>
            <p className="community-extra-subtitle">
              Member conversations, replies, friends, and notifications stay inside the authenticated community space.
            </p>
            <button
              type="button"
              className="community-forum-public-button"
              onClick={() => loginWithRedirect()}
            >
              Sign in to open the forum
            </button>
          </section>
        )}
      </div>
    </div>
  )
}
